import { NEEDLE_AND_SHARP_CHECKLIST } from './needleAndSharpPolicy';
import { SIREN_NUTRITION_ITEM } from './sirenBundlePolicy';

export const palette = {
  primary: "#6F4CF6",
  green: "#22C55E",
  amber: "#F59E0B",
  red: "#EF4444",
  blue: "#3B82F6",
};

/** Quality report by month — รายงานคุณภาพ (เดือน) */
export const QUALITY_REPORT_MONTHLY_LINK = {
  label: "รายงานคุณภาพ (เดือน)",
  url: "https://drive.google.com/drive/u/0/folders/1O68e8tY9iLEzdpKEqlekZcM2Vfs72Wsl",
} as const;

/** KPI quarterly — KPI (ทำส่งทุกไตรมาส) */
export const KPI_QUARTERLY_LINK = {
  label: "KPI (ทำส่งทุกไตรมาส)",
  url: "https://drive.google.com/drive/u/0/folders/1X5aQoC8g4Hi967E4eWZoOGtmr2zA0Wem",
  tier: "todo-quality" as const,
};

/** OP-IP Voice quality work link — Google Drive */
export const OP_IP_VOICE_LINK = {
  label: "OP-IP Voice",
  url: "https://drive.google.com/drive/folders/1NxVQSjmdUbqmGovQhEwQRsQnwI37QjWh",
} as const;

/** Nurse inspector plan quarterly — แผนผู้ตรวจการพยาบาลรายไตรมาส */
export const NURSE_INSPECTOR_PLAN_LINK = {
  label: "แผนผู้ตรวจการพยาบาลรายไตรมาส",
  url: "https://drive.google.com/drive/u/0/folders/1_O2oZnd_Z9SugqLz0U-W1teMjAC3DjeQ",
} as const;

/** Building plan quarterly — แผนตึกรายไตรมาส */
export const BUILDING_PLAN_LINK = {
  label: "แผนตึกรายไตรมาส",
  url: "https://drive.google.com/drive/u/0/folders/1BeSqufXTvGu9BcTEFHwzfntZXFgIqpTA",
} as const;

/** Working team plan quarterly — แผนคณะทำงาน รายไตรมาส */
export const WORKING_TEAM_PLAN_LINK = {
  label: "แผนคณะทำงาน รายไตรมาส",
  url: "https://drive.google.com/drive/u/0/folders/1UoSiE4NjtQJGZGpUxMxzvxzjmbeScJuj",
} as const;

/** Quality improvement activities — กิจกรรมพัฒนาคุณภาพ */
export const QUALITY_IMPROVEMENT_ACTIVITIES_LINK = {
  label: "กิจกรรมพัฒนาคุณภาพ",
  url: "https://drive.google.com/drive/u/0/folders/1PinaXTzm3zWc350o53pej8E69-b0HcTZ",
} as const;

/** Orders and announcements — คำสั่ง/ประกาศ */
export const ORDERS_ANNOUNCEMENTS_LINK = {
  label: "คำสั่ง/ประกาศ",
  url: "https://drive.google.com/drive/u/0/folders/1O9Rz86fpFMdXD_DYkLcoBqy4dDiaj4uL",
} as const;

/** Service profile annual — Service Profile รายปี */
export const SERVICE_PROFILE_LINK = {
  label: "Service Profile รายปี",
  url: "https://drive.google.com/drive/u/0/folders/1jSn4EGGbqJrwfncRTYl6Su7xwy8NQUb8",
} as const;

/** Same ordering as ComplianceHub HeaderBar — todo-quality (KPI quarterly) first among todos. */
export function sortQualityWorkLinks<T extends { label: string; tier?: string }>(links: readonly T[]): T[] {
  return [...links].sort((a, b) => {
    const aTodo = a.tier === "todo-quality" ? 0 : 1;
    const bTodo = b.tier === "todo-quality" ? 0 : 1;
    if (aTodo !== bTodo) return aTodo - bTodo;
    if (aTodo === 0) return a.label.localeCompare(b.label);
    return 0;
  });
}

/** External Google Forms shown on the Home grid for every department and every HEAD_WARD_NURSE. */
export const NSO_HUB_MONTHLY_QUALITY_REPORT_LINK = {
  label: "NSO Hub รายงานคุณภาพประจำเดือน",
  url: "https://script.google.com/macros/s/AKfycbxYX8X8mPzvryF1nGg-XU1W50Z3ZudvKNQhbFcMNQ_bcwq45z7ktsUvqL8QiCw2A6vI8w/exec",
} as const;

export const PATIENT_JOURNEY_FORM_LINK = {
  label: "Patient Journey (ทำไตรมาสละครั้ง)",
  url: "https://docs.google.com/forms/d/e/1FAIpQLSdytjhT_N6NK2KXMMRqoDwXfs8yvT9uqwM2008blpu_ofQHow/viewform",
} as const;

export const ETHIC_ROUND_FORM_LINK = {
  label: "Ethic Round Form (ทำเดือนละครั้ง)",
  url: "https://docs.google.com/forms/d/e/1FAIpQLSdC7t5Km9y4YbP2GDA_fD0aoJJNw1R6KCnQpNTJ5NlxWrI7rw/viewform",
} as const;

export const WARD_GOOGLE_FORM_LINKS = [
  NSO_HUB_MONTHLY_QUALITY_REPORT_LINK,
  PATIENT_JOURNEY_FORM_LINK,
  ETHIC_ROUND_FORM_LINK,
] as const;

/** List of quality work links for dropdown (e.g. in SN navbar) and งานคุณภาพ cards */
export const QUALITY_WORK_LINKS = [
  QUALITY_IMPROVEMENT_ACTIVITIES_LINK, // กิจกรรมพัฒนาคุณภาพ
  ORDERS_ANNOUNCEMENTS_LINK, // คำสั่ง/ประกาศ
  OP_IP_VOICE_LINK, // OP-IP Voice
  SERVICE_PROFILE_LINK, // Service Profile รายปี
  WORKING_TEAM_PLAN_LINK, // แผนคณะทำงาน รายไตรมาส
  BUILDING_PLAN_LINK, // แผนตึกรายไตรมาส
  NURSE_INSPECTOR_PLAN_LINK, // แผนผู้ตรวจการพยาบาลรายไตรมาส
  QUALITY_REPORT_MONTHLY_LINK, // รายงานคุณภาพ (เดือน)
  KPI_QUARTERLY_LINK, // KPI (ทำส่งทุกไตรมาส)
] as const;

export const SUPERVISION_RECIPIENT_OPTIONS = [
  { value: "individual", label: "รายบุคคล" },
  { value: "custom", label: "ระบุ" },
  { value: "group", label: "รายกลุ่ม" },
];

export const SUPERVISION_ACTIVITY_OPTIONS = [
  { value: "rounds", label: "การเยี่ยมตรวจทางการพยาบาล (nursing rounds)" },
  { value: "conference", label: "การประชุมปรึกษาทางการพยาบาล (nursing conference)" },
  { value: "teaching", label: "การสอน (teaching)" },
  { value: "problem-solving", label: "การแก้ปัญหา (problem-solving)" },
  { value: "counseling", label: "การให้คำปรึกษา" },
  { value: "observation", label: "การสังเกต (observation)" },
  { value: "collaboration", label: "การร่วมมือปฏิบัติงาน" },
];

export const SUPERVISION_ISSUE_OPTIONS = [
  { value: "manpower", label: "การจัดอัตรากำลัง" },
  { value: "assignment", label: "การมอบหมายงาน" },
  { value: "equipment", label: "อุปกรณ์เครื่องมือเครื่องใช้" },
  { value: "environment", label: "สถานที่สิ่งแวดล้อมและ 5 ส" },
  { value: "energy", label: "อนุรักษ์พลังงาน" },
  { value: "disease-standard", label: "มาตรฐานการดูแลผู้ป่วยรายโรค" },
  { value: "medication", label: "การบริหารยา" },
  { value: "blood", label: "การบริหารเลือด" },
  { value: "identification", label: "การบ่งชี้" },
  { value: "specimen", label: "การเก็บสิ่งส่งตรวจ" },
  { value: "fall", label: "การป้องกันFall" },
  { value: "needleandsharp", label: "การป้องกันเข็มทิ่มตำ" },
  { value: "phlebitis", label: "การป้องกัน Phlebitis" },
  { value: "pre-op", label: "การเตรียมผู้ป่วยส่งทำผ่าตัด /หัตถการ" },
  { value: "isitdown", label: "ISITDOWN" },
  { value: "nurse_notes", label: "บันทึกทางการพยาบาล" },
  { value: "ic", label: "IC" },
  { value: "service", label: "พฤติกรรมบริการ" },
  { value: "attire", label: "การแต่งกาย" },
  { value: "self-development", label: "การอบรมพัฒนาตนเอง" },
  { value: "staff-health", label: "การส่งเสริมสขภาพกายใจเจ้าหน้าที่" },
  { value: "patient-education", label: "การสอนแนะนำผู้ป่วย" },
  { value: "other", label: "อื่นๆระบุ......" },
];

export const DEFAULT_CHARTS = 10;
export const DEFAULT_CHOICE = "NA";
export const CHOICE_VALUES = new Set(["1", "0", DEFAULT_CHOICE]);

export type ChecklistSection = {
  title?: string;
  description?: string;
  note?: string;
  items: string[];
};

export type ChecklistDisplaySection = ChecklistSection & { rows: { label: string; index: number }[] };

export const CARD_CONFIGS: Record<
  string,
  {
    charts?: number;
    label?: string;
    teamLabel?: string;
  }
> = {
  "บันทึกทางการพยาบาล": {
    charts: 8,
    label: "Chart",
    teamLabel: "คณะทำงานพัฒนาระบบบันทึกทางการพยาบาล",
  },
  "เข็มตำ/ของมีคมบาด": {
    charts: DEFAULT_CHARTS,
    label: "ครั้งที่",
    teamLabel: "คณะทำงานบริหารจัดการความเสี่ยง",
  },
  "นิเทศระบบยา": { charts: 4, label: "สัปดาห์", teamLabel: "คณะทำงานความคลาดเคลื่อนทางยา" },
  "SIREN bundle": { charts: 5, label: "HN", teamLabel: "คณะทำงาน Palliative, Pain, and Pressure Injury" },
  "นิเทศทางการพยาบาล": {
    charts: 1,
    label: "ครั้งที่",
    teamLabel: "คณะทำงานนิเทศทางการพยาบาล",
  },
};

/** Canonical nursing compliance slot count (hub progress / badge use this; extra charts beyond this are optional). */
export const REQUIRED_NURSING_CHARTS = CARD_CONFIGS["บันทึกทางการพยาบาล"]?.charts ?? DEFAULT_CHARTS;

/** Canonical นิเทศระบบยา (`med_error`) required rounds; extra rounds are optional via +เพิ่มครั้ง. */
export const REQUIRED_MED_ERROR_CHARTS = CARD_CONFIGS["นิเทศระบบยา"]?.charts ?? 4;

/** Canonical SIREN bundle HN columns. The paper form is exactly five columns. */
export const REQUIRED_SIREN_BUNDLE_CHARTS = CARD_CONFIGS["SIREN bundle"]?.charts ?? 5;

export const CHECKLISTS: Record<string, ChecklistSection[]> = {
  "บันทึกทางการพยาบาล": [
    {
      items: [
        "เกณฑ์ข้อ 1 การประเมินแรกรับ",
        "เกณฑ์ข้อ 2 การระบุปัญหาทางการพยาบาล",
        "เกณฑ์ข้อ 3 กิจกรรมการพยาบาล",
        "เกณฑ์ข้อ 4 การตอบสนองการรักษาพยาบาล",
        "เกณฑ์ข้อ 5 การให้ข้อมูลระหว่างการดูแล",
        "เกณฑ์ข้อ 6 การเตรียมความพร้อมผู้ป่วยเพื่อการดูแลตนเองต่อเนื่องที่บ้าน",
        "เกณฑ์ข้อ 7 การประสานการดูแลต่อเนื่อง",
        "เกณฑ์ข้อ 8 การเตรียมผู้ป่วยก่อนจำหน่าย",
        "เกณฑ์ข้อ 9 การบันทึกวันเดือนปี เวลา การลงลายมือชื่อ",
      ],
    },
  ],
  "เข็มตำ/ของมีคมบาด": NEEDLE_AND_SHARP_CHECKLIST,
  "นิเทศระบบยา": [
    {
      title: "การรับคำสั่ง",
      items: [
        "ตรวจสอบความถูกต้องซ้ำในใบ MAR กับคำสั่งรายการยาของแพทย์",
        "\"High Alert Drug\" มีการตรวจสอบร่วมกันในคำสั่งยา (Double check) กรณีที่มีพยาบาลปฏิบัติหน้าที่คนเดียว สามารถตรวจสอบซ้ำด้วยตนเองได้ (Recheck)",
        "ประสานกับแพทย์ กรณีที่คำสั่งไม่ชัดเจน หรือไม่ถูกต้อง",
      ],
    },
    {
      title: "การรับยา",
      items: [
        "ตรวจสอบยาที่รับจากห้องยากับใบนำส่งให้ถูกต้อง ก่อนจัดเก็บยาเข้ากล่องบรรจุ",
        "ประสานเภสัชกร กรณีได้รับยาไม่ถูกต้อง ไม่ครบถ้วน",
      ],
    },
    {
      title: "การจัดเก็บยา",
      items: [
        "จัดเก็บยาสำหรับผู้ป่วยเฉพาะราย",
        "\"High Alert Drug\" จัดเก็บแยกจากยาอื่น - ติดเครื่องหมายที่กล่องบรรจุยา / Syringe ยา / ชื่อยาในใบ MAR",
        "ยา LASA มีป้ายติดที่ซองยา / ภาชนะที่จัดเก็บ / ใบ MAR",
        "ยา Multiple dose มี Sticker เริ่มใช้ / หมดอายุ",
        "ยาเสพติดแยกเก็บจากยาอื่น ใส่ลิ้นชักมีกุญแจล็อค",
        "มีการตรวจสอบการใช้ยาเสพติด โดยลงบันทึกในแบบฟอร์มการบันทึกการใช้ยาเสพติด",
      ],
    },
    {
      title: "การบริหารยา (ใช้หลัก 7R)",
      items: [
        "จัดยาตามใบ MAR โดยตรวจสอบยาในซองยาให้ถูกต้องตรงกัน",
        "Double check / Recheck ก่อนให้ยา",
        "\"High Alert Drug\" มีการใช้ Infusion pump, Syringe pump หรือ ควบคุมจำนวนหยด",
        "\"High Alert Drug\" ตรวจสอบจำนวนหยดร่วมกัน (Double check)",
        "ตรวจสอบระบุตัวถูกต้อง โดยตรวจสอบป้ายข้อมือให้ตรงกับ Sticker ยาและใบ MAR",
        "กรณีให้สารน้ำหรือสารละลาย ติด Sticker :- Start, Expire ที่ IV Site ของผู้ป่วยทุกราย",
        "กรณีให้สารน้ำหรือสารละลาย ติดป้ายบ่งชี้ที่ขวดพร้อมลงข้อมูลครบถ้วน",
        "ให้ข้อมูลผู้ป่วย / ญาติเมื่อให้ยา",
        "บันทึกเวลาที่ให้ยาจริง (Realtime) และบันทึกชื่อพยาบาลผู้ให้ในใบ MAR ทุกครั้ง",
        "บันทึกการพยาบาลเฝ้าระวัง \"High Alert Drug\" เกี่ยวกับ - ความเสี่ยงที่อาจเกิดขึ้นจากการที่ผู้ป่วยได้รับยา - การสังเกตอาการไม่พึงประสงค์ - การให้ข้อมูลแก่ผู้ป่วย/ผู้ดูแล",
        "มีการ Round สารน้ำหรือสารละลายเพื่อตรวจสอบความถูกต้องตรงกับคำสั่งการรักษา - \"High Alert Drug Round ทุก 1-2 ชั่วโมง - สารน้ำทั่วไป Round IV อย่างน้อยทุก 4 ชั่วโมง",
      ],
    },
    {
      title: "การตรวจสอบอื่น ๆ",
      items: [
        "ยาสำรองตามระบบมีบันทึกการตรวจสอบความพร้อมใช้ทุกเวร",
        "CPR box มีสายคาด สภาพพร้อมใช้",
        "ไม่พบยาค้าง / ยาที่แพทย์สั่ง off ในกล่องบรรจุยาผู้ป่วย",
        "มีการตรวจสอบอุณหภูมิตู้เย็นเก็บยา ตามข้อกำหนด",
        "สถานที่จัดยา \"สงบ สะอาด สว่าง\"",
      ],
    },
  ],
  "SIREN bundle": [
    {
      title: "SKIN",
      items: [
        "1. ประเมินสภาพผิวหนังตั้งแต่แรกรับ โดยเฉพาะตามปุ่มกระดูก",
        "2. บำรุงผิวให้มีความชุ่มชื้นโดยการทาโลชั่น หรือปิโตรเลียมออยท์เม้นท์แต่ไม่เปียกแฉะ",
        "3. ใช้วัสดุปิดแผล ปิดที่ร่องหูบริเวณเชือกผูกท่อช่วยหายใจพาดผ่าน ( กรณีไม่ใส่ท่อช่วยหายใจให้ ใส่ NA ในข้อนี้ )",
      ],
    },
    {
      title: "Incontinence",
      items: [
        "1.ทำความสะอาดผิวหนังทุกครั้งเมื่อมีการขับถ่าย และซับให้แห้ง",
        "2.หลีกเลี่ยงการขัดถูผิวหนังอย่างรุนแรงปกป้องผิวหนังจากการสัมผัสสิ่งขับถ่ายด้วยผลิตภัณฑ์ต่างๆเช่น วาสลิน",
        "3.ใช้ครีมปกป้องผิวหนังทา / พ่นเมื่อเกิดความเสียหายของผิวหนัง",
      ],
    },
    {
      title: "Relief",
      items: [
        "1. พลิกตะแคงตัวทุก 2 ชั่วโมง",
        "2. ใช้ที่นอนลมในผู้ป่วยที่มีความเสี่ยง (โดยเฉพาะBraden ≤14 ต้อง ใช้ทุกราย)",
        "3. ใช้ผ้ารองในการยกตัวผู้ป่วย ไม่ดึง-ลากผู้ป่วย",
      ],
    },
    {
      title: "Evaluation",
      items: [
        "1. ประเมินความเสี่ยงการเกิดแผลกดทับโดยใช้ Braden Scoreและบันทึกลงใน Intervention ในรายที่มีความเสี่ยง ( คะแนน≤18) โดยประเมินซ้ำทุกวัน",
        "2. ประเมิน DTI ในผู้ป่วยที่มีการใช้อุปกรณ์ทางการแพทย์ทุกครั้งทึ่มีการ Turn Position ป้องกันภาวะ Medical Device Related Pressure Injury  ( MDRPI )( กรณีไม่ใส่ท่อช่วยหายใจ ใส่ NA ในข้อนี้ )",
      ],
    },
    {
      title: "Nutrition",
      description: "มีการประเมินโภชนาการ โดยมีผลประเมินดังนี้ (*ถ้าใช่ = 1 คะแนน* , *ถ้าไม่ = 0 คะแนน*)",
      note: "หากคะแนนมากกว่าเท่ากับ 2 ให้ปรึกษานักโภชนาการ หากน้อยกว่าให้คัดกรองซ้ำทุกสัปดาห์",
      items: [SIREN_NUTRITION_ITEM],
    },
  ],
};
